// extracted by mini-css-extract-plugin
module.exports = {"manualEditOptionsWrapper":"c5PP2X_s","iconAndLabelWrapper":"ej9qDWU9","clickableIconAndLabelWrapper":"j6SfRDaj ej9qDWU9","manualEditOptionsLabelText":"HTYV8cxl"};